import {
  ZBNI_PHONE_NUMBER_EGYPT,
  ZBNI_PHONE_NUMBER_HONGKONG,
  ZBNI_PHONE_NUMBER_JORDAN,
  ZBNI_PHONE_NUMBER_KSA,
  ZBNI_PHONE_NUMBER_UAE,
} from "app/config/constants";
import KSA from "app/images/about-us_KSA.png";
import dubai from "app/images/about-us_dubai.png";
import egypt from "app/images/about-us_egypt.png";
import jordan from "app/images/about-us_jordan.png";
import hongkong from "app/images/about-us_hongkong.png";
import team from "app/images/about-us_team.png";
import phoneIcon from "app/images/phone-icon.png";
import { Trans, useTranslation } from "react-i18next";
import classNames from "classnames";
import parsePhoneNumber from "libphonenumber-js";

const Locations = () => {
  const { t: trans } = useTranslation();
  return [
    {
      picture: dubai,
      country: trans("UAE"),
      address1: trans("Mazaya Business Avenue"),
      address2: trans("Tower AA1, Office 3205"),
      area: trans("Jumeirah Lake Towers, Dubai"),
      phoneNumber: ZBNI_PHONE_NUMBER_UAE,
    },
    {
      picture: KSA,
      country: trans("KSA"),
      address1: trans("8087 Handalah Ibn Malik"),
      address2: trans("Office 167, 1st Floor"),
      area: trans("Al Woroud District, Riyadh"),
      phoneNumber: ZBNI_PHONE_NUMBER_KSA,
    },
    {
      picture: jordan,
      country: trans("Jordan"),
      address1: trans("King Hussein Business Park Building number 7"),
      address2: trans("V Business Center, 3rd floor Office 304"),
      area: trans("Amman"),
      phoneNumber: ZBNI_PHONE_NUMBER_JORDAN,
    },
    {
      picture: egypt,
      country: trans("Egypt"),
      address1: trans("CO-55 - City center"),
      address2: trans("Makram Ebied - Nasr city"),
      area: trans("Cairo"),
      phoneNumber: ZBNI_PHONE_NUMBER_EGYPT,
    },
    {
      id: "hongkong",
      picture: hongkong,
      country: trans("Hong Kong"),
      address1: trans("Zbooni HK, Unit 1411, 14th Floor, Cosco Tower"),
      address2: trans("183 Queen's Road Central"),
      area: trans("Sheung Wan"),
      phoneNumber: ZBNI_PHONE_NUMBER_HONGKONG,
    },
  ];
};

export const TeamAndLocationsSection = () => {
  const locations = Locations();

  return (
    <section className="relative h-full w-full font-montserrat">
      <div
        id="team"
        style={{ backgroundImage: `url(${team})` }}
        className="flex min-h-[430px] bg-cover bg-top bg-no-repeat lg:min-h-[470px]"
      >
        <div className="flex flex-1 items-center justify-center bg-primary opacity-80">
          <div className="zbooni-layout text-white">
            <div className="max-w-3xl text-center">
              <p className="pb-8 text-3xl font-extrabold">
                <Trans>Our Team</Trans>
              </p>
              <p className="font-bold">
                <Trans>
                  The Zbooni family keeps growing with individuals who are
                  passionate about preserving human connections amidst
                  technological innovation, and leading industry change.
                </Trans>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div id="locations" className="scroll-mt-10">
        <div className="bg-lightgray">
          <div className="zbooni-layout flex flex-col py-20">
            <div className="text-center">
              <p className="text-3xl font-extrabold">
                <Trans>Our Locations</Trans>
              </p>
            </div>
            <div className="mt-10 grid grid-cols-1 gap-10 sm:px-[20%] lg:grid-cols-12 lg:px-20">
              {locations.map((location, index) => (
                <div
                  key={index}
                  style={{ backgroundImage: `url(${location.picture})` }}
                  className={classNames(
                    "col-span-1 flex min-h-[182px] w-full rounded-3xl bg-cover bg-bottom bg-no-repeat lg:col-span-6 lg:min-h-[280px]",
                    location.id === "hongkong" ? "lg:!col-end-10" : ""
                  )}
                  lang={location.id === "hongkong" ? "en" : undefined}
                >
                  <div className="flex flex-1 rounded-3xl bg-gradient-to-bl from-transparent to-black">
                    <div className="flex flex-1 p-7 lg:px-5 xl:p-11">
                      <div className="flex h-full flex-col justify-between gap-y-7 font-medium text-white">
                        <p className="text-[22px] lg:text-2xl">
                          {location.country}
                        </p>
                        <div
                          className={classNames("w-full text-sm lg:text-base", {
                            "w-full ltr:max-w-[200px] ltr:lg:max-w-[250px] rtl:lg:max-w-[200px]":
                              index == 2,
                          })}
                        >
                          <p>{location.address1}</p>
                          <p>{location.address2}</p>
                        </div>
                        <p className="text-sm lg:text-base">{location.area}</p>
                        <div className="flex items-center gap-x-2">
                          <img
                            className="h-7 w-7 invert"
                            src={phoneIcon}
                            alt=""
                          />
                          <a href={`tel:${location.phoneNumber}`} lang="en">
                            {parsePhoneNumber(
                              location.phoneNumber || ""
                            )?.formatInternational()}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
